import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { BASE_URL, PUBLIC_BASE } from 'app/config';

export class HtmlHeader extends React.PureComponent {
  constructor(props) {
    super(props);

    this.getImageUrl = this.getImageUrl.bind(this);
  }

  getImageUrl() {
    const { imageUrl, url } = this.props;
    const isRelative = imageUrl.startsWith('/');

    return isRelative ? `${url}${imageUrl}` : imageUrl;
  }

  render() {
    const {
      title,
      description,
      canonicalPath,
      locale,
      url,
      index,
      children,
    } = this.props;
    const imageUrl = this.getImageUrl();

    return (
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:url" content={url} />
        <meta property="og:site_name" content="heycar" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={locale} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image:url" content={imageUrl} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@heycar_official" />
        <meta name="twitter:creator" content="@heycar_official" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:url" content={url} />
        <meta name="twitter:image" content={imageUrl} />
        <meta name="twitter:description" content={description} />

        <meta name="robots" content={index} />

        {canonicalPath && <link rel="canonical" href={canonicalPath} />}

        {children}

        <script type="application/ld+json">
          {`
        {
          "@context" : "https://schema.org",
          "@type" : "Organization",
          "url" : "https://hey.car",
          "brand" : "heycar",
          "address" : {
            "@type" : "PostalAddress",
            "addressLocality" : "Berlin",
            "addressCountry" : "DE",
            "postalCode" : "13353",
            "streetAddress" : "Müllerstraße 153"
          },
          "logo" : "https://hey.car/heycar_color.jpg",
          "sameAs" : [
            "https://www.facebook.com/heycar.official/",
            "https://twitter.com/heycar_official",
            "https://www.linkedin.com/company/heycar/",
            "https://www.youtube.com/channel/UCMFkEo9GkQjLH7jAYPw7doA",
            "https://www.crunchbase.com/organization/heycar"
          ]
        }`}
        </script>
        <script type="application/ld+json">
          {`
        {
          "@context" : "https://schema.org",
          "@type" : "WebSite",
          "url" : "https://hey.car",
          "potentialAction" : {
            "@type" : "SearchAction",
            "target" : "https://hey.car/gebrauchtwagen?page=0&q={search_term_string}",
            "query-input" : "required name=search_term_string"
          }
        }
        `}
        </script>
      </Helmet>
    );
  }
}

HtmlHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  canonicalPath: PropTypes.string,
  locale: PropTypes.string,
  imageUrl: PropTypes.string,
  url: PropTypes.string,
  index: PropTypes.string,
  children: PropTypes.node,
};

HtmlHeader.defaultProps = {
  locale: 'de-DE',
  imageUrl: `${PUBLIC_BASE}/assets/heycar_link.jpg`,
  url: BASE_URL,
  index: 'noindex,nofollow',
  description: '',
  canonicalPath: '',
};
